// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-7b0d22f1]{width:100%;text-align:center;border-bottom:1px solid #000;line-height:.1em;margin:10px 0 20px}p span[data-v-7b0d22f1]{background:#f6f6f6;padding:0 10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
